export const DocumentTemplateSectionColumnFragment = gql`
  fragment DocumentTemplateSectionColumnFragment on DocumentTemplateSectionColumn {
    id
    label
    order
    style
    type
  }
`
